import React from 'react';

/** Responsive spinner with four visual sizes. */
const LOADING_SPINNER_VARIANTS = {
  small: { size: 'h-4 w-4', border: 'border-2' },
  default: { size: 'h-6 w-6 sm:h-8 sm:w-8', border: 'border-2' },
  large: {
    size: 'h-8 w-8 sm:h-10 sm:w-10 md:h-12 md:w-12',
    border: 'border-2 sm:border-4',
  },
  prominent: {
    size: 'h-10 w-10 sm:h-12 sm:w-12 md:h-16 md:w-16 lg:h-20 lg:w-20',
    border: 'border-4 md:border-8',
  },
} as const;

const LOADING_SPINNER_COLORS = {
  orange: 'border-orange-200 border-t-orange-500 text-orange-500',
  yellow: 'border-yellow-100 border-t-yellow-400 text-yellow-400',
} as const;

export type LoadingSpinnerVariant = keyof typeof LOADING_SPINNER_VARIANTS;
export type LoadingSpinnerColor = keyof typeof LOADING_SPINNER_COLORS;

export const LoadingSpinner: React.FC<{
  variant?: LoadingSpinnerVariant;
  color?: LoadingSpinnerColor;
}> = ({ variant = 'default', color = 'orange' }) => {
  const config = LOADING_SPINNER_VARIANTS[variant];
  return (
    <div
      className={`
        ${config.size}
        ${config.border}
        ${LOADING_SPINNER_COLORS[color]}
        animate-spin rounded-full
      `}
      role="status"
      aria-label="Loading"
    />
  );
};
